import { Navigate } from "react-router-dom";
import { useAuth } from "app/providers/authContext";
import PropTypes from "prop-types";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { user, isLoading, hasPermission } = useAuth();

  if (isLoading) {
    return (
      <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
        <MDTypography variant="h4">Cargando...</MDTypography>
      </MDBox>
    );
  }

  if (!user) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  requiredPermission: PropTypes.string,
};

export default ProtectedRoute;
